import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo_topspin.png';

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Sobre */}
          <div className="flex flex-col items-start">
            <img src={logo} alt="TopSpinFit Academia" className="h-16 mb-4" />
            <p className="text-gray-300 mb-4">
              Na TopSpinFit você nunca mais vai se sentir perdido nem desanimado nos treinos. 
              Oferecemos atendimento com treinos personalizados, conforto e segurança.
            </p>
            <div className="flex space-x-4 mt-2">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/topspinfit/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
              <a href="https://wa.me/5585992405667" target="_blank" rel="noopener noreferrer" className="text-white hover:text-primary transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.498 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.101-.473-.15-.673.15-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.174-.3-.019-.465.13-.615.136-.135.301-.345.451-.523.146-.181.194-.301.297-.496.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.172-.015-.371-.015-.571-.015-.2 0-.523.074-.797.359-.273.3-1.045 1.02-1.045 2.475s1.07 2.865 1.219 3.075c.149.195 2.105 3.195 5.1 4.485.714.3 1.27.48 1.704.629.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z" />
                  <path d="M20.52 3.449a12.871 12.871 0 00-9.073-3.769c-7.173 0-13.007 5.834-13.007 13.007 0 2.294.547 4.53 1.598 6.55l-1.699 6.2 6.349-1.667c1.953.97 4.138 1.48 6.359 1.48h.006c7.173 0 13.007-5.833 13.007-13.007 0-3.407-1.325-6.61-3.734-9.02zm-6.52 19.892c-1.905 0-3.77-.51-5.392-1.47l-.395-.214-4.01 1.05 1.067-3.9-.229-.364a10.807 10.807 0 01-1.652-5.737c0-5.959 4.85-10.809 10.811-10.809 2.887 0 5.598 1.124 7.635 3.162a10.729 10.729 0 013.169 7.645c0 5.96-4.851 10.811-10.809 10.811z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-xl font-bold mb-4 border-b border-primary pb-2">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-primary transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/nossa-academia" className="text-gray-300 hover:text-primary transition-colors">Nossa Academia</Link>
              </li>
              <li>
                <Link to="/modalidades" className="text-gray-300 hover:text-primary transition-colors">Modalidades</Link>
              </li>
              <li>
                <Link to="/unidades" className="text-gray-300 hover:text-primary transition-colors">Unidades</Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-300 hover:text-primary transition-colors">Contato</Link>
              </li>
            </ul>
          </div>

          {/* Unidades */}
          <div>
            <h3 className="text-xl font-bold mb-4 border-b border-primary pb-2">Nossas Unidades</h3>
            <div className="space-y-4">
              <div>
                <h4 className="font-semibold text-primary">Luciano Cavalcante</h4>
                <p className="text-gray-300 flex items-start mt-1">
                  <svg className="w-4 h-4 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Rua Esperança, 56 – Luciano Cavalcante
                  <br />CEP 60.811-243
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-primary">Messejana</h4>
                <p className="text-gray-300 flex items-start mt-1">
                  <svg className="w-4 h-4 mr-2 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Rua Chico França, 720 – Messejana
                  <br />CEP 60.871-100
                </p>
              </div>
            </div>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xl font-bold mb-4 border-b border-primary pb-2">Contato</h3>
            <div className="space-y-3">
              <p className="flex items-center text-gray-300">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                (85) 3055-1414
              </p>
              <p className="flex items-center text-gray-300">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                (85) 99240-5667
              </p>
              <div className="mt-4">
                <a href="https://academiatopspinfit.sitesca.com/matricular" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Matrícula Online</a>
              </div>
            </div>
          </div>
        </div>

        {/* App Download */}
        <div className="mt-12 border-t border-gray-700 pt-8 pb-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-6 md:mb-0">
              <h3 className="text-xl font-bold mb-2">Baixe nosso aplicativo</h3>
              <p className="text-gray-300">Acompanhe seu progresso e tenha acesso a rotinas personalizadas</p>
            </div>
            <div className="flex space-x-4">
              <a href="https://play.google.com/store/apps/details?id=com.sistemasca.scafit&hl=pt_BR&gl=US" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105">
                <img src="/google-play-badge.png" alt="Google Play" className="h-10" />
              </a>
              <a href="https://apps.apple.com/br/app/sca-aluno/id1630928165" target="_blank" rel="noopener noreferrer" className="transition-transform hover:scale-105">
                <img src="/app-store-badge.png" alt="App Store" className="h-10" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-8 pt-6 border-t border-gray-700">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} TopSpinFit Academia. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
